var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clinicSelectorDropdownWrapper"},[_c('v-select',{staticClass:"filterSelector",attrs:{"items":_vm.allClinics,"label":"Select Clinic","item-text":"Company","item-value":"Practice_ID"},model:{value:(_vm.selectedClinicId),callback:function ($$v) {_vm.selectedClinicId=$$v},expression:"selectedClinicId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }